import { Component, OnInit } from '@angular/core';
import { Title }     from '@angular/platform-browser';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  private usuario: any = {}

  constructor(private title: Title) { }

  ngOnInit() {
    this.title.setTitle("Dashboard");
    this.usuario = JSON.parse(localStorage.getItem("usuario"));

    let empresa = localStorage.getItem("empresa");
    let sucursal = localStorage.getItem("sucursal");

    let abrir = false;
    if(empresa == '')
      abrir = true;
    else{
      if(sucursal == '')
        abrir = true;
    }

    if(abrir)
      document.getElementById("cambiar_empresa").click();
  }

}
